import * as Yup from 'yup';

export const login_schema = {
  email: '',
  password: '',
};

export const login_validation_schema = Yup.object({
  email: Yup.string().email('Invalid email').required('Email is required'),
  password: Yup.string().required('Password is required'),
});
